export const internalURLRequestInterceptor = (config) => {
  const { baseURL, url } = config

  if (baseURL && url?.includes(baseURL)) {
    config.url = url.replace(baseURL, '')
  }

  return config
}
